module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Light-Oblique.ff88849d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GT-Walsheim-Light-Oblique.ttf
// module id = 654
// module chunks = 0